import React, { useState, useEffect } from 'react'
import {
  Button,
  DatePicker,
  Icon,
  ProvideTypeahead,
  RaytebForm,
  Table,
  TextBox,
  Typeahead,
  TypeaheadText,
} from '../../../share/Elements'
import { LoadingFit, RaytebModal } from '../../../share/Components'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import {
  MedicationPrescriptionType,
  PrescriptionViewModel,
} from '../../../models/ViewModels/PrescriptionViewModel'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import { useDispatch, useSelector } from 'react-redux'
import { ReducerType } from '../../../storeManager/ReducerType'
import useFetch from '../../../_services/fetch'
import { RaytebRequests } from '../../../_services'
import { SaveMedicationViewModel } from '../../../models/ViewModels/SaveMedicationViewModel'
import {
  addOrUpdatePrescription,
  addFavoriteMedicationRow,
  updateMedicationRow,
  updateShouldPush,
  deleteFavoriteMedicationRow,
} from '../../../storeManager/Reducers/prescriptionSlice'
import { toast } from 'react-toastify'
import { MedictionChosenViewModel } from '../../../models/ViewModels/MedicationRowChosenViewModel'
import { ErrorTypeEnum } from '../../../_services/ResponseErrorType'
import { GetPriceViewModel } from '../../../models/ViewModels/GetPriceViewModel'
import { ReactElement } from 'react'


type TypeaheadData = {
  show: boolean
  data?: any
}
const Medication = ({
  medication,
  prescriptionId,
  isPreview,
  insuranceType,
  setButtomPage,
}: {
  medication: MedicationPrescriptionType
  prescriptionId: string
  isPreview?: boolean
  insuranceType: number,
  setButtomPage?: (child: ReactElement | null) => void
}) => {
  const dispatch = useDispatch()
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const [search, setSearch] = useState<MedicationDrugInterfaceInputModel>({
    chosen: false,
    isIRC: false,
    filter: '',
  })
  const [insertBookmarkPrescriptionModal, setInsertBookmarkPrescriptionModal] =
    useState<boolean>(false)
  const [showBookmarkPrescriptionModal, setShowBookmarkPrescriptionModal] =
    useState<boolean>(false)
  const [paramSaveRow, setParamSaveRow] = useState<SaveMedicationInputModel>({})
  const [data, setData] = useState<MedicationDrugViewModel | null>()
  const saveMedication = useFetch<
    SaveMedicationViewModel,
    SaveMedicationInputModel
  >({
    request: RaytebRequests.Medication_AddOrUpdate_POST({
      description: '',
      token: user.token,
    }),
    onSuccess(data) {
      dispatch(updateMedicationRow(data.rows))
      dispatch(updateShouldPush(true))
      setShowModal({ show: false })
      setParamSaveRow({})
      setButtomPage?.(null)
      setData({ isEdit: false, title: '', code: '' })

      data.messages.forEach((n) => {
        toast[n.flag](n.message)
      })
    },
  })
  const saveMedicationRange = useFetch<
    SaveMedicationViewModel,
    SaveMedicationRangeInputModel
  >({
    request: RaytebRequests.Medication_AddRange_POST({
      token: user.token,
    }),
    onSuccess(data) {
      dispatch(updateMedicationRow(data.rows))
      dispatch(updateShouldPush(true))
      setShowModal({ show: false })
      setShowList({ ...showList, show: false })
      setParamSaveRow({})
      setButtomPage?.(null)
      setData({ isEdit: false, title: '', code: '' })

      data.messages.forEach((n) => {
        toast[n.flag](n.message)
      })
    },
  })
  const getLastMedication = useFetch<
    SaveMedicationInputModel,
    {},
    { code: string }
  >({
    request: RaytebRequests.Medication_GetLastMedication_GET({
      token: user.token,
    }),
    onSuccess(data) {
      setParamSaveRow({
        ...paramSaveRow,
        totalNumber: data.totalNumber,
        amount: data.amount,
        amountUnitId: data.amountUnitId,
        description: data.description,
        frequencyId: data.frequencyId,
      })
      setShowModal({ ...showList, show: true })
      setShowList({ ...showList, show: false })
      setButtomPage?.(buttomElement)
      setTimeout(() => {
        document.getElementById('TotalNumber')?.focus()
      }, 200)
    },
  })
  const deleteMedication = useFetch<
    PrescriptionViewModel,
    unknown,
    {
      prescriptionId: string
      id: string
    }
  >({
    request: RaytebRequests.Medication_Remove_DELETE({ token: user.token }),
    onSuccess(data) {
      data.shouldPush = true
      dispatch(addOrUpdatePrescription(data))
    },
  })
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const { reFetch, isLoading, result } = useFetch<
    Array<MedicationDrugViewModel>
  >({
    request: RaytebRequests.Medication_Drugs_GET(search, {
      headers: { centerId: center.id },
      token: user.token,
    }),
  })
  const addBookmarkDrug = useFetch<unknown, unknown, { rowId: string }>({
    request: RaytebRequests.Medication_BookmarkDrug_POST({ token: user.token }),
    onSuccess(data) {
      dispatch(
        addFavoriteMedicationRow(
          medication.rows?.find((n) => n.id === addBookmarkDrug.query?.rowId)
        )
      )
      toast.success('ریز نسخه با موفقیت به علاقه مندی ها اضافه شد')
    },
  })

  const drugRequirements = useFetch<Array<DrugRequirementsViewModel>, unknown, { insuranceType: number }>({
    request: RaytebRequests.Medication_DrugRequirements_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    fetchInitialLoad: false,
  })
  const frequencies = useFetch<Array<AmountUnitViewModel>>({
    request: RaytebRequests.Medication_Frequencys_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    fetchInitialLoad: true,
  })
  const [listBookmarkSearch, setListBookmarkSearch] = useState<
    Array<ListBookmarkViewModel> | undefined
  >([])
  const listBookmark = useFetch<Array<ListBookmarkViewModel>>({
    request: RaytebRequests.Medication_Bookmark_Get({
      token: user.token,
    }),
    onSuccess(data) {
      setListBookmarkSearch(data)
    },
  })
  const bookmark = useFetch<
    unknown,
    unknown,
    { medicationId: string; title: string }
  >({
    request: RaytebRequests.Medication_Bookmark_POST({ token: user.token }),
    onSuccess(data) {
      toast.success('نسخه برگزیده با موفقیت ثبت شد')
      setInsertBookmarkPrescriptionModal(false)
    },
  })
  const [price, setPrice] = useState<GetPriceViewModel>({})
  const getPrice = useFetch<
    GetPriceViewModel,
    unknown,
    {
      rowId: string
      prescriptionId: string
    }
  >({
    request: RaytebRequests.Medication_GetPrice_GET({ token: user.token }),
    onSuccess(data) {
      data.show = true
      setPrice(data)
    },
  })
  const bookmarkDelete = useFetch<unknown, unknown, { bookmarkId: string }>({
    request: RaytebRequests.Medication_Bookmark_Delete({ token: user.token }),
    onSuccess(data) {
      listBookmark.reFetch()
    },
  })
  const [listAddedChosen, setListAddedChosen] =
    useState<MedictionChosenViewModel>({ rows: [], prescription: {} })

  const [bulk, setBulk] = useState<{ bulkId?: number; isBulk?: boolean }>()
  const addChosen = useFetch<
    MedictionChosenViewModel,
    unknown,
    { prescriptionId: string; medicationId: string }
  >({
    request: RaytebRequests.Medication_AddChosen_Post({ token: user.token }),
    onSuccess(data) {
      setListAddedChosen(data)
      if (data.rows?.some((n) => n.isAdded)) {
        data.prescription!.shouldPush = true
        dispatch(addOrUpdatePrescription(data.prescription))
      }
    },
  })
  const deleteBookmarkDrug = useFetch<unknown, unknown, { code: string }>({
    request: RaytebRequests.Medication_BookmarkDrugDelete_DELETE({
      token: user?.token,
    }),
    onSuccess(data) {
      dispatch(deleteFavoriteMedicationRow(deleteBookmarkDrug.query?.code))
      reFetch()
    },
  })

  const [showList, setShowList] = useState<TypeaheadData>({
    show: false,
  })
  const [showModal, setShowModal] = useState<TypeaheadData>({
    show: false,
  })
  const buttomElement = (
    <>
      <div className='mt-2 flex justify-center items-center px-6 gap-10 w-full '>
        <Button
          type='button'
          onClick={() => {
            setData({ title: '', isEdit: false })
            setShowModal({ ...showList, show: false })
            setParamSaveRow({ title: '' })
            setButtomPage?.(null)
          }}
          className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs w-full h-9 !shadow-lg md:!w-56'
        >
          انصراف
        </Button>
        <Button
          onClick={() => {
            document.getElementById('saveMedicationSubmit')?.click()
          }}
          className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg md:!w-56'
        >
          تایید
        </Button>
      </div>
    </>
  )

  const selectedItem = (item: MedicationDrugViewModel) => {
    setData({
      ...data,
      title: item.title,
      shape: item.shape,
      icon: item.icon,
      code: item.code,
      isEdit: true,
    })
    getLastMedication.reFetch(undefined, {
      code: item.code!,
    })
    setSearch({ ...search, filter: '' })
  }
  useEffect(() => {
    if (!isPreview) reFetch()
  }, [search])
  useEffect(() => {
    drugRequirements.reFetch(null, { insuranceType: insuranceType })
  }, [])
  return (
    <>
      <div className='py-5 relative'>
        <LoadingFit
          isLoading={
            deleteMedication.isLoading ||
            frequencies.isLoading ||
            drugRequirements.isLoading ||
            saveMedication.isLoading ||
            bookmark.isLoading ||
            getPrice.isLoading
          }
        />

        <div className='px-2'>
          {!isPreview ? (
            <ProvideTypeahead
              className={`relative  ${data?.isEdit
                ? 'before:absolute before:z-50 before:bg-white/30 before:w-full before:h-full'
                : ''
                }`}
              showList={showList.show}
              listChildren={
                search.chosen ? (
                  <ListCheckChildren
                    onDelete={(row) =>
                      deleteBookmarkDrug.reFetch(null, { code: row.code! })
                    }
                    hasDelete={search.chosen}
                    onHide={() => setShowList({ ...showList, show: false })}
                    isLoading={
                      saveMedicationRange.isLoading ||
                      deleteBookmarkDrug.isLoading ||
                      isLoading
                    }
                    onClick={(item) => {
                      if (item.length === 0) {
                        toast.error('هیچ ریز نسخه ای انتخاب نشده')
                        return
                      }
                      saveMedicationRange.reFetch({
                        listCode: item,
                        prescriptionId: prescriptionId,
                      })
                    }}
                    listData={result}
                  />
                ) : (
                  <ListChildren
                    onDelete={(row) =>
                      deleteBookmarkDrug.reFetch(null, { code: row.code! })
                    }
                    hasDelete={search.chosen}
                    onHide={() => setShowList({ ...showList, show: false })}
                    isLoading={isLoading}
                    onClick={(item) => {
                      selectedItem(item)
                    }}
                    listData={result}
                  />
                )
              }
            >
              <div className='px-1 flex justify-start items-end md:!w-1/2 md:mx-auto'>
                <Typeahead
                  innerText='نام یا کد دارویی'
                  className={`!w-full`}
                  isLtR={true}
                  onClick={(e) => {
                    e.target.select()
                  }}
                  onFocus={() => setShowList({ ...showList, show: true })}
                  // onBlur={() => setShowList({ ...showList, show: false })}
                  onChange={(e) => {
                    setSearch({ ...search, filter: e.target.value })
                  }}
                  value={data?.title}
                >
                  <Icon
                    icon='rayteb-ehr'
                    className={`!text-2xl mr-3 !text-primaryLight`}
                    onClick={() => setShowBookmarkPrescriptionModal(true)}
                  />
                  <Icon
                    icon='rayteb-star-two'
                    className={`!text-2xl ${search.chosen ? 'text-warn' : '!text-primaryLight'
                      } `}
                    onClick={() =>
                      setSearch({ ...search, chosen: !search.chosen })
                    }
                  />
                </Typeahead>
                <Icon
                  icon='rayteb-irc'
                  className={`!text-4xl h-7 w-7 ${search.isIRC ? '!text-secondaryLight' : '!text-primaryLight'
                    }`}
                  onClick={() => {
                    setSearch({ ...search, isIRC: !search.isIRC })
                  }}
                />
                <Icon
                  icon={`rayteb-electuary `}
                  className={`!text-3xl   h-7 w-7  ${bulk?.isBulk ? 'text-fuchsia-600' : '!text-primaryLight'
                    } `}
                  onClick={() => {
                    var arr = medication.rows?.map((n) => n.bulkId ?? 0) ?? [1]
                    setBulk({
                      isBulk: !bulk?.isBulk,
                      bulkId: Math.max(...arr, 1),
                    })
                  }}
                />
              </div>
            </ProvideTypeahead>
          ) : (
            ''
          )}
          {showModal.show && !isPreview ? (
            <>
              {bulk?.isBulk ? (
                <div className='flex justify-start items-center gap-2'>
                  <p className='py-3 text-xs text-warnDark underline underline-offset-8'>
                    دسته دارویی شماره {bulk.bulkId}
                  </p>
                  <Button
                    onClick={() =>
                      setBulk({ ...bulk, bulkId: bulk.bulkId! + 1 })
                    }
                    className='!p-0 bg-secondary !text-lg mr-2
                   !text-white !h-7 !w-7 !rounded-full'
                  >
                    +
                  </Button>
                  <Button
                    onClick={() =>
                      setBulk({ ...bulk, bulkId: bulk.bulkId! - 1 })
                    }
                    className='!p-0 bg-danger !text-lg
                   !text-white !h-7 !w-7 !rounded-full'
                  >
                    -
                  </Button>
                </div>
              ) : (
                ''
              )}
              <RaytebForm
                className='relative'
                checkIsRequired={true}
                onSubmit={(e) => {
                  saveMedication.reFetch({
                    ...paramSaveRow,
                    prescriptionId: prescriptionId,
                    code: data?.code || paramSaveRow.code,
                    effectiveDate:
                      e.currentTarget['EffectiveDate'].getAttribute(
                        'rayteb-value'
                      ),
                    description: e.currentTarget['Description'].value,
                    repeatCount: e.currentTarget['Repeat'].value,
                    totalNumber: e.currentTarget['TotalNumber'].value,
                    bulkId: bulk?.isBulk ? bulk?.bulkId : 0,
                  })
                }}
              >
                <LoadingFit isLoading={getLastMedication.isLoading} />
                <div className='w-full p-1 grid grid-cols-2 py-3 gap-x-3 gap-y-6'>
                  <TextBox
                    id='TotalNumber'
                    innerText='تعداد'
                    name='TotalNumber'
                    value={paramSaveRow.totalNumber?.toString()}
                    Type={TextBoxTypeEnum.Number}
                    className='w-full !border-0 !border-b !rounded-none
             !focus:border-0 !focus:border-b focus:!ring-0'
                    isRequired={true}
                  />
                  <TypeaheadText<AmountUnitViewModel>
                    debounceTime={0}
                    selected={(e) => {
                      setParamSaveRow({
                        ...paramSaveRow,
                        amountUnitId: e.id,
                      })
                    }}
                    isReadOnly={true}
                    hasSearch={true}
                    value={drugRequirements.result?.map(n => { return { shapeTitle: n.shapeTitle, title: n.amountUnitTitle, id: n.amountUnitId } })
                      .find(
                        (n) => n.id === paramSaveRow.amountUnitId
                      )}
                    listData={drugRequirements.result?.map(n => { return { shapeTitle: n.shapeTitle, title: n.amountUnitTitle, id: n.amountUnitId } })
                      ?.filter((n) => n.shapeTitle?.includes(data?.shape!))
                      .distinct('title')}
                    fieldItem='title'
                    fieldValue='id'
                    innerText='واحد مصرف'
                    isRequired={true}
                    className='!bg-white !w-full'
                    classNameList='h-40'
                  />
                  <TypeaheadText<{
                    value: number
                    title: string
                  }>
                    debounceTime={0}
                    selected={(e) => {
                      setParamSaveRow({ ...paramSaveRow, amount: e.value })
                    }}
                    listData={drugRequirements.result?.filter(x => x.amountUnitId === paramSaveRow.amountUnitId)
                      .map(n => { return { value: n.amount, title: n.amountTitle } })
                      .distinct('title').sort((x, b) => x.value - b.value)}
                    fieldItem='title'
                    fieldValue='value'
                    isReadOnly={true}
                    value={drugRequirements.result?.filter(x => x.amountUnitId === paramSaveRow.amountUnitId)
                      .map(n => { return { value: n.amount, title: n.amountTitle } }).find(
                        (n) => n.value === paramSaveRow.amount
                      )}
                    hasSearch={true}
                    innerText='میزان مصرف'
                    isRequired={true}
                    className='!bg-white'
                    classNameList='h-40'
                  />

                  <TypeaheadText<FrequencyViewModel>
                    selected={(e) => {
                      setParamSaveRow({
                        ...paramSaveRow,
                        frequencyId: e.id,
                      })
                    }}
                    hasSearch={true}
                    listData={frequencies.result}
                    fieldItem='title'
                    fieldValue='id'
                    debounceTime={0}
                    value={frequencies.result?.find(
                      (n) => n.id === paramSaveRow.frequencyId
                    )}
                    innerText='زمان مصرف'
                    isRequired={true}
                    isReadOnly={true}
                    className='!bg-white !w-full'
                    classNameList='h-40'
                  />
                  <DatePicker
                    name='EffectiveDate'
                    innerText='تاریخ تکرار'
                    canDeleteDate={true}
                    value={
                      paramSaveRow.effectiveDate
                        ? new Date(paramSaveRow.effectiveDate).toShamsi()
                        : ''
                    }
                    raytebValue={paramSaveRow.effectiveDate}
                    className='w-full !border-0 !border-b !rounded-none
             !focus:border-0 !focus:border-b focus:!ring-0'
                  />
                  <TypeaheadText<{
                    value: number
                    title: string
                  }>
                    selected={(e) => {
                      setParamSaveRow({ ...paramSaveRow, repeatType: e.value })
                    }}
                    listData={[
                      { title: 'روز', value: 0 },
                      { title: 'هفته', value: 1 },
                      { title: 'ماه', value: 2 },
                    ]}
                    fieldItem='title'
                    fieldValue='value'
                    isReadOnly={false}
                    innerText='نوع تکرار نسخه'
                    className='!bg-white'
                    classNameList='h-20'
                  />
                  <TextBox
                    innerText='دوره تکرار'
                    Type={TextBoxTypeEnum.Number}
                    value={paramSaveRow.repeatCount?.toString()}
                    name='Repeat'
                    className='w-full border-0 border-b rounded-none
             focus:!border-0 focus:!border-b focus:!ring-0'
                  />
                  <div className='col-span-2 mt-3'>
                    <TextBox
                      name='Description'
                      value={paramSaveRow.description}
                      innerText='توضیحات دارو'
                      Type={TextBoxTypeEnum.Text}
                      className='!w-full  h-20'
                    />
                  </div>
                </div>
                <input
                  type='submit'
                  className='hidden'
                  id='saveMedicationSubmit'
                />
              </RaytebForm>
            </>
          ) : (
            <>
              {medication.rows && medication.rows?.length != 0 ? (
                <div className='w-full  mt-6'>
                  <Table>
                    <thead className='text-xs text-primary h-8 border-b border-disable'>
                      <tr>
                        <th
                          scope='col'
                          className='pt-1 p-0 text-center font-normal'
                        >
                          نام دارو
                        </th>
                        <th
                          scope='col'
                          className='pt-1 text-center font-normal'
                        >
                          تعداد
                        </th>
                        <th
                          scope='col'
                          className='pt-1 text-center font-normal'
                        >
                          نحوه مصرف
                        </th>
                        <th
                          scope='col'
                          className='pt-1 pl-2 text-center font-normal '
                        >
                          تاریخ موثر
                        </th>
                        <th
                          scope='col'
                          className='pt-1 pl-2 text-center font-normal '
                        >
                          عملیات
                        </th>
                      </tr>
                    </thead>
                    <tbody className='text-xs '>
                      {[...(medication.rows ?? [])]
                        .sort(function (a, b) {
                          return `${b.bulkId}`.localeCompare(`${a.bulkId}`)
                        })
                        ?.map((row, i) => (
                          <tr
                            className={`[&>*]:h-16  ${row.isDeleted ? 'opacity-50 ' : ''
                              }`}
                            key={i}
                          >
                            <td
                              className='text-center decoration-dotted underline underline-offset-4 relative
                         text-primary'
                            >
                              <p
                                onClick={() =>
                                  getPrice.reFetch(null, {
                                    prescriptionId: prescriptionId,
                                    rowId: row.id!,
                                  })
                                }
                              >
                                {row.title?.shortText(40)}
                              </p>
                              <div className='absolute flex gap-2 top-1 '>
                                <span className='bg-warn text-[9px] font-bold rounded-full px-1'>
                                  {row.bulkId !== 0
                                    ? `دسته ${row.bulkId}`
                                    : 'معمولی'}
                                </span>
                                <Icon
                                  icon='rayteb-star-two'
                                  className={`!text-sm col-span-2 ${row.isFavorite ? 'text-warn' : ''
                                    }`}
                                  onClick={() =>
                                    addBookmarkDrug.reFetch(null, {
                                      rowId: row.id!,
                                    })
                                  }
                                />
                              </div>
                            </td>
                            <td className='text-center'>{row.totalNumber}</td>
                            <td className='text-center'>
                              {`${frequencies.result?.find(
                                (n) => n.id == row.frequencyId
                              )?.title
                                } ${row.amount}`}
                            </td>
                            <td className='text-center'>
                              {row.effectiveDate
                                ? new Date(row.effectiveDate).toShamsi()
                                : ''}
                            </td>
                            <td className='grid grid-cols-2 justify-items-center p-1 gap-1'>
                              {!row.isDeleted ? (
                                <>
                                  <Icon
                                    icon='rayteb-delete'
                                    className='text-[17px] text-danger'
                                    onClick={() => {
                                      deleteMedication.reFetch(null, {
                                        prescriptionId: prescriptionId,
                                        id: row.id!,
                                      })
                                    }}
                                    disabled={isPreview}
                                  />
                                  <Icon
                                    icon='rayteb-edit'
                                    className='text-[17px] text-warn'
                                    onClick={() => {
                                      setParamSaveRow(row)
                                      setData({
                                        title: row.title!,
                                        isEdit: true,
                                        shape: drugRequirements.result?.find(
                                          (n) => n.shapeTitle === row.shapeTitle
                                        )?.shapeTitle,
                                      })
                                      setShowModal({ show: true })
                                      setButtomPage?.(buttomElement)
                                    }}
                                    disabled={isPreview}
                                  />
                                </>
                              ) : (
                                ''
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                  <div className='flex justify-center px-2 mt-3'>
                    <Button
                      className=' text-xs bg-secondary text-white py-1'
                      onClick={() => {
                        setInsertBookmarkPrescriptionModal(true)
                      }}
                      disabled={isPreview}
                    >
                      ثبت نسخه به برگزیده
                    </Button>
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          )}
        </div>
      </div>
      <RaytebModal
        isOpen={insertBookmarkPrescriptionModal}
        hideModal={() => setInsertBookmarkPrescriptionModal(false)}
        title='ثبت نسخه برگزیده'
      >
        <RaytebForm
          className='flex justify-center items-center flex-col gap-5 py-6'
          checkIsRequired={true}
          onSubmit={(e) => {
            bookmark.reFetch(null, {
              medicationId: medication.id!,
              title: e.currentTarget['bookmark'].value,
            })
          }}
        >
          <div className='w-[80%]'>
            <TextBox
              Type={TextBoxTypeEnum.Text}
              isRequired={true}
              innerText='عنوان نسخه برگزیده'
              name='bookmark'
            />
          </div>
          <div className='mt-2 flex justify-center items-center px-6 gap-10 w-full'>
            <Button
              type='button'
              onClick={() => {
                setInsertBookmarkPrescriptionModal(false)
              }}
              className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              انصراف
            </Button>
            <Button
              type='submit'
              className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              تایید
            </Button>
          </div>
        </RaytebForm>
      </RaytebModal>
      <RaytebModal
        isOpen={showBookmarkPrescriptionModal}
        hideModal={() => {
          setShowBookmarkPrescriptionModal(false)
          setListAddedChosen({ rows: [] })
        }}
        onAfterOpen={() => {
          listBookmark.reFetch()
        }}
        title='لیست نسخه های پرگزیده'
        className={'p-2 relative w-96'}
      >
        <LoadingFit
          isLoading={
            listBookmark.isLoading ||
            bookmarkDelete.isLoading ||
            addChosen.isLoading
          }
        />
        <div className='py-3 h-80 overflow-y-auto'>
          {listAddedChosen.rows?.length === 0 ? (
            <>
              <TextBox
                innerText='جستجو'
                Type={TextBoxTypeEnum.Text}
                debounceTime={0}
                onChange={(e) => {
                  const bookmarks = listBookmark.result?.filter((x) =>
                    x.title.includes(e.target.value)
                  )
                  setListBookmarkSearch(bookmarks)
                }}
              />
              <Table>
                <thead className='text-xs text-primary h-8 border-b border-disable'>
                  <tr>
                    <th
                      scope='col'
                      className='pt-1 p-0 text-center font-normal w-10'
                    >
                      #
                    </th>
                    <th
                      scope='col'
                      className='pt-1 p-0 text-center font-normal'
                    >
                      نام
                    </th>
                    <th
                      scope='col'
                      className='pt-1 pl-2 text-center font-normal w-10'
                    >
                      عملیات
                    </th>
                  </tr>
                </thead>
                <tbody className='text-xs'>
                  {listBookmarkSearch?.map((item, i) => (
                    <tr className={`[&>*]:h-14`} key={i}>
                      <td className='text-center'>{i + 1}</td>
                      <td className='text-center'>
                        {item.title?.shortText(40)}
                      </td>

                      <td className='grid grid-cols-2 justify-items-center p-1 gap-3'>
                        <Icon
                          icon='rayteb-delete'
                          className='text-[17px] text-danger'
                          onClick={() =>
                            bookmarkDelete.reFetch(null, {
                              bookmarkId: item.id,
                            })
                          }
                        />
                        <Icon
                          icon='rayteb-add-circular'
                          className='text-[17px] text-secondary'
                          onClick={() => {
                            addChosen.reFetch(null, {
                              prescriptionId: prescriptionId!,
                              medicationId: item.prescriptionId,
                            })
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          ) : (
            <div className='w-full px-2'>
              <div className='text-xs grid grid-cols-8 justify-items-start items-center gap-3'>
                <span className='col-span-3'>نام دارو</span>
                <span className='col-span-1'>مقدار</span>
                <span className='col-span-2'>میزان مصرف</span>
                <span className='col-span-2'>تاریخ تکرار</span>
                {listAddedChosen.rows?.map((row, i) => (
                  <>
                    <span className='text-center flex justify-center items-center col-span-3'>
                      {row.title?.shortText(13)}
                    </span>
                    <span className='text-center flex justify-center items-center col-span-1'>
                      {row.totalNumber}
                    </span>
                    <span className='text-center flex justify-center items-center col-span-2'>
                      {`${frequencies.result?.find((n) => n.id == row.frequencyId)
                        ?.title
                        } ${row.amount}`}
                    </span>
                    <span className='text-center flex justify-center items-center col-span-2'>
                      {row.effectiveDate
                        ? new Date(row.effectiveDate).toShamsi()
                        : ''}
                    </span>
                    {row.messages?.map((n) => (
                      <>
                        <span
                          className={`col-span-8 w-full py-1 border-b ${n.flag === ErrorTypeEnum.Error
                            ? 'text-danger'
                            : n.flag === ErrorTypeEnum.Info
                              ? 'text-primaryLight'
                              : n.flag === ErrorTypeEnum.Warning
                                ? 'text-warn'
                                : ''
                            }`}
                        >
                          {n.message}
                        </span>
                      </>
                    ))}
                  </>
                ))}
              </div>
            </div>
          )}
        </div>
      </RaytebModal>
      <RaytebModal
        isOpen={price.show ?? false}
        hideModal={() => setPrice({ show: false })}
        title='قیمت خدمت'
      >
        <div className='p-2'>
          <Table>
            <thead className='text-xs text-primary h-8 border-b border-disable'>
              <tr>
                <th
                  scope='col'
                  className='pt-1 p-0 text-center font-normal w-10'
                >
                  سهم سازمان
                </th>
                <th scope='col' className='pt-1 p-0 text-center font-normal'>
                  سهم بیمار
                </th>
                <th
                  scope='col'
                  className='pt-1 pl-2 text-center font-normal w-10'
                >
                  کل
                </th>
              </tr>
            </thead>
            <tbody className='text-xs'>
              <tr className={`[&>*]:h-14`}>
                <td className='text-center'>{price.insureShare}</td>
                <td className='text-center'>{price.patientShare}</td>

                <td className='text-center'>{price.total}</td>
              </tr>
            </tbody>
          </Table>
          <div className='text-xs w-full flex flex-col gap-3'>
            {price.messages?.map((n) => (
              <span
                className={`${n.flag === ErrorTypeEnum.Error
                  ? 'text-danger'
                  : n.flag === ErrorTypeEnum.Info
                    ? 'text-primaryLight'
                    : n.flag === ErrorTypeEnum.Warning
                      ? 'text-warn'
                      : ''
                  }`}
              >
                {n.message}
              </span>
            ))}
          </div>
        </div>
      </RaytebModal>
    </>
  )
}
type ListChildrenType = {
  listData?: Array<MedicationDrugViewModel>
  className?: string | undefined
  isLoading: boolean
  hasDelete: boolean
  onDelete?: (row: MedicationDrugViewModel) => void
  onHide?: () => void
  onClick?: (param: MedicationDrugViewModel) => void
}
type ListCheckChildrenType = {
  listData?: Array<MedicationDrugViewModel>
  className?: string | undefined
  isLoading: boolean
  hasDelete: boolean
  onDelete?: (row: MedicationDrugViewModel) => void
  onHide?: () => void
  onClick?: (param: Array<string>) => void
}

const ListChildren: React.FC<ListChildrenType> = ({
  className,
  listData,
  isLoading,
  hasDelete,
  onDelete,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div className=''>
        <LoadingFit isLoading={isLoading} />
        <div className='border-b border-disable bg-white py-2 px-1 flex items-center'>
          <Icon
            icon='rayteb-android-close'
            className='text-xl'
            onClick={() => onHide?.()}
          />

          <p className='text-xs mr-2 font-bold text-warn '>
            برای تجویز بر روی یکی از موارد کلیک کنید
          </p>
        </div>

        <div className='h-64 overflow-y-auto'>
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm  ${className ?? ''}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className={`flex ${hasDelete ? ' justify-between' : ' justify-end'
                  } items-center  w-full my-1 hover:bg-primaryDefault hover:cursor-pointer`}
              >
                {hasDelete ? (
                  <Icon
                    icon={`rayteb-delete`}
                    className='text-xl text-danger'
                    onClick={() => onDelete?.(n)}
                  />
                ) : (
                  ''
                )}
                <div
                  onClick={() => onClick?.(n)}
                  className='flex justify-end items-center w-full'
                >
                  <p className='text-xs font-bold text-end text-primaryLight'>
                    {n.title}
                  </p>
                  <Icon
                    icon={`rayteb-${n.icon}`}
                    className='text-3xl text-secondaryLight'
                  />
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  )
}

const ListCheckChildren: React.FC<ListCheckChildrenType> = ({
  className,
  listData,
  isLoading,
  hasDelete,
  onDelete,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div className=''>
        <LoadingFit isLoading={isLoading} />
        <div className='border-b border-disable bg-white py-2 px-1 flex items-center'>
          <Icon
            icon='rayteb-android-close'
            className='text-xl'
            onClick={() => onHide?.()}
          />

          <p className='text-xs mr-2 font-bold text-warn '>
            برای تجویز بر روی یکی از موارد کلیک کنید
          </p>
        </div>

        <div className='h-64 overflow-y-auto relative'>
          <RaytebForm
            onSubmit={(e) => {
              onClick?.(
                Array(...e.target.getElementsByTagName('input'))
                  .filter((n) => n.checked)
                  .map((n) => n.value)
              )
            }}
          >
            <ul
              className={`flex justify-center flex-col  
           items-center p-2 shadow-sm gap-3 ${className ?? ''}`}
            >
              {listData?.map((n, i) => (
                <li
                  key={i}
                  className={`flex ${hasDelete ? ' justify-between' : ' justify-end'
                    } items-center  w-full `}
                >
                  {hasDelete ? (
                    <Icon
                      icon={`rayteb-delete`}
                      className='text-xl text-danger'
                      onClick={() => onDelete?.(n)}
                    />
                  ) : (
                    ''
                  )}
                  <div className='flex justify-center items-center'>
                    <label
                      htmlFor={n.code}
                      className='text-xs font-bold text-end text-primaryLight'
                    >
                      {n.title}
                    </label>
                    <input
                      type='checkbox'
                      id={n.code?.toString()}
                      name={n.code?.toString()}
                      value={n.code}
                      className='mr-2'
                    />
                  </div>
                </li>
              ))}
            </ul>
            <Button
              type='submit'
              className='w-36 bg-secondary !text-white py-1 absolute bottom-2 left-[50%]
            -translate-x-[50%]'
            >
              ثبت
            </Button>
          </RaytebForm>
        </div>
      </div>
    </>
  )
}
export default React.memo(Medication)
